export enum FetchStatus {
  FAILURE = 'failure',
  PENDING = 'pending',
  SUCCESS = 'success',
}
